import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { GiHamburgerMenu } from "react-icons/gi";
import { FaTimes } from "react-icons/fa";
import { BrowserRouter as Router, Link } from "react-router-dom";
import ThemeToggle from "./ThemeToggle";

const Navbar = () => {
  const [navbar, setNavbar] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [theme, setTheme] = useState(
    () => localStorage.getItem("theme") || "light"
  );

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScrolled(window.scrollY > 50);
    });

    return () => window.removeEventListener("scroll", () => setScrolled(false));
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () =>
    setTheme((prev) => (prev === "light" ? "dark" : "light"));
  const toggleNavbar = () => setNavbar(!navbar);

  return (
    <nav
      className={`sticky top-0 z-50 py-3 border-neutral-700/80 transition-all ${
        theme === "light"
          ? "bg-white border-b-2 border-dashed"
          : "bg-gray-900 text-white border-b-2 border-dashed"
      }`}
    >
      <div className="container px-4 mx-auto relative">
        <div className="flex justify-between items-center">
          <span className="font-semibold text-[24px] cursor-pointer hover:text-slate-300 transition-all tracking-wide">
            <Link to="/">Naveen Kumar</Link>
          </span>

          {/* Navbar Toggle Button with Animation */}

          <button
            onClick={toggleTheme}
            className=" flex md:hidden p-2 rounded-lg bg-gray-200 dark:bg-gray-800 text-gray-900 dark:text-gray-100"
          >
            <ThemeToggle />
          </button>

          {/* Desktop Menu */}
          <div
            className={`hidden lg:flex items-center space-x-10 ${
              theme === "light" ? "bg-white" : "bg-gray-900 text-white"
            }`}
          >
            {/* <Link to="/blogs" className="hover:text-gray-500">
              BLOGS
            </Link> */}
            <button
              onClick={toggleTheme}
              className="p-2 rounded-lg bg-gray-200 dark:bg-gray-800 text-gray-900 dark:text-gray-100"
            >
              <ThemeToggle />
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
      </div>
    </nav>
  );
};

export default Navbar;
